import { SecondaryButton } from "@/components/buttons/SecondaryButton";
import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { useQueryClient } from "@tanstack/react-query";
import { Card } from "antd";
import { useTranslation } from "react-i18next";
import { JOBS_QUERY_KEYS, useGetJobs } from "../../../common/api/queries/jobs";
import AntIcon from "../../../common/components/icons/AntIcon";
import { JobSettingsView } from "../components/views/JobSettingsView";

export const JobsContainer = () => {
  const { t } = useTranslation();

  const queryClient = useQueryClient();
  const { refetch } = useGetJobs();

  return (
    <ContentWrapper>
      <Card
        className="card-box"
        title={<h2 className="margin-bottom-medium">{t("job.titles.page")}</h2>}
        extra={
          <SecondaryButton
            size="small"
            icon={<AntIcon type="reload" />}
            onClick={async () => {
              await refetch();
              queryClient.invalidateQueries({ queryKey: JOBS_QUERY_KEYS.filterJobRecords() });
            }}
          >
            {t("job.actions.refresh")}
          </SecondaryButton>
        }
      >
        <JobSettingsView />
      </Card>
    </ContentWrapper>
  );
};
